import { render, staticRenderFns } from "./AdminSelectedOrdersMaterial.vue?vue&type=template&id=b2348302&scoped=true"
import script from "./AdminSelectedOrdersMaterial.vue?vue&type=script&lang=js"
export * from "./AdminSelectedOrdersMaterial.vue?vue&type=script&lang=js"
import style0 from "./AdminSelectedOrdersMaterial.vue?vue&type=style&index=0&id=b2348302&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2348302",
  null
  
)

export default component.exports